
import { useEffect, useState } from 'react';
import { useOrderContext } from '../../context/OrderContext';
import { useUserContext } from '../../context/UserContext';
import Link from '@material-ui/core/Link';
import { orderActionTypes, OrderStatus } from '../../app/enums';
import { DataGrid, GridRowsProp, GridColDef, GridCellParams } from '@mui/x-data-grid';
import { Typography } from '@material-ui/core';
import dateFormat from 'dateformat';
import { Orders } from '../../api/api'; 
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    dataGridRoot:{
      border: 0,
      '& .header' : {
        background: theme.palette.background.default,
        color: theme.palette.primary.dark,
        fontWeight: '600', 
        fontSize: 16,
        padding: theme.spacing(0),
      },
      '& .MuiDataGrid-menuIconButton': {
        color: theme.palette.primary.dark,
        size: 'small',
        padding: theme.spacing(0),
      },
      '& .MuiDataGrid-sortIcon': {
        color: theme.palette.primary.dark,
        size: 'small',
        padding: theme.spacing(0),
      },
      headerHeight: 45,
      rowHeight: 40,
      pageSize: 10,
    },
  }),
);

export const OrderGrid = () => {
  const classes = useStyles(); 
  const { state, dispatch } = useOrderContext();
  const user = useUserContext();
  const [ page, setPage ] = useState(0)

  const handleButtonClick = (orderId: string) => {
    dispatch({type: 'field', fieldName: 'orderId', payload:orderId})
  };

  const loadOrderList = () => {
    Orders.getSelfOrders(user.state.self.locations[0].id)
      .then((orderList) => {
          dispatch({ type: orderActionTypes.LOAD_ORDER_LIST, orderList: orderList})
      })
      .catch((error) => {
        console.log('Order details error', error)
      }) 
  }

  useEffect(() => {
    loadOrderList();
  }, [state.orderId])

  const columns: GridColDef[] = [
    { 
      field: 'order', 
      headerClassName: 'header', 
      headerAlign: 'center',
      headerName: 'Order Number', 
      flex: 5,
      renderCell: (params: GridCellParams) => (
        (params.getValue(params.id, 'orderNumber') + '').length > 0 
        ? <Link 
            onClick = {() => handleButtonClick(params.getValue(params.id, 'orderId') + '')}>
            {params.getValue(params.id, 'orderNumber')}
          </Link>
        : <Link 
            onClick = {() => handleButtonClick(params.getValue(params.id, 'orderId') + '')}>
            {params.value}
          </Link>
      ),
    },
    { 
      field: 'orderPlaced', headerClassName: 'header', 
      headerAlign: 'center',headerName: 'Ordered On', 
      flex: 3,
      renderCell: (params: GridCellParams) => (
        params.value !== undefined && params.value !== null
        ?
          <Typography variant="inherit" display="inline">  
          {dateFormat(new Date(params.value + ''), "mmm dd, yyyy")}  
          </Typography>
        : ''
      )
    },
    { 
      field: 'status',
      headerClassName: 'header', 
      headerAlign: 'center', 
      headerName: 'Status', 
      flex: 3,
      renderCell: (params: GridCellParams) => (
        <Typography variant="inherit" display="inline">  
          {OrderStatus[params.value as keyof typeof OrderStatus]}
        </Typography>     
      )
    },
  ];
  
  const rows: GridRowsProp = state.orderList.map((item) => ({
    id: item.id,
    orderId: item.id,
    orderNumber: item.orderNumber || '',
    order: item.orderNumber || item.id,
    orderPlaced: item.createdAt,
    status: item.status.toString(),
  }));

  return (
    <>
      <div style={{ height: 500, width: '100%' }} className={classes.dataGridRoot}>
        <DataGrid 
          rows={rows} 
          columns={columns} 
          pageSize={10} 
          rowHeight={40} 
          headerHeight={45}
          page={page}
          onPageChange={(newPage) => setPage(newPage)}
      />
      </div>
    </>
  )
};

export default OrderGrid;
